export * from "./classes/tab";

export * from "./components/tabset";

export * from "./directives/tab-content";
export * from "./directives/tab-header";

export * from "./tab.module";
